import {
  FibudPartners,
  OnBoardComplete,
  OnBoardCreateAward,
  OnBoardCreateCareer,
  OnBoardCreateDegree,
  OnBoardCreateEducation,
  OnBoardCreateGym,
  OnBoardCreateLecture,
  OnBoardCreateLicense,
  OnBoardGymSearch,
  OnBoardIntro,
  OnBoardSearchEducation,
  OnBoardSearchLicense,
  OnBoardStep
} from '#pages';
import { OnBoardEditAward } from '#pages/OnBoardEditAward';
import { OnBoardEditCareer } from '#pages/OnBoardEditCareer';
import { OnBoardEditDegree } from '#pages/OnBoardEditDegree';
import { OnBoardEditEducation } from '#pages/OnBoardEditEducation';
import { OnBoardEditLicense } from '#pages/OnBoardEditLicense';
import { Fragment, Suspense } from 'react';
import { Route, Routes } from 'react-router';

export function OnBoardView() {
  return (
    <Fragment>
      <Suspense fallback={<></>}>
        <Routes>
          <Route path="/" element={<OnBoardIntro />} />
          <Route path="/step" element={<OnBoardStep />} />
          <Route path="/degree" element={<OnBoardCreateDegree />} />
          <Route path="/degree/:degreeId" element={<OnBoardEditDegree />} />
          <Route path="/career" element={<OnBoardCreateCareer />} />
          <Route path="/career/:careerId" element={<OnBoardEditCareer />} />
          <Route path="/license" element={<OnBoardCreateLicense />} />
          <Route path="/license/:licenseId" element={<OnBoardEditLicense />} />
          <Route path="/license/search" element={<OnBoardSearchLicense />} />
          <Route path="/award" element={<OnBoardCreateAward />} />
          <Route path="/award/:awardId" element={<OnBoardEditAward />} />
          <Route path="/education" element={<OnBoardCreateEducation />} />
          <Route
            path="/education/:educationId"
            element={<OnBoardEditEducation />}
          />
          <Route
            path="/education/search"
            element={<OnBoardSearchEducation />}
          />
          <Route path="/lecture" element={<OnBoardCreateLecture />} />
          <Route path="/gym/search" element={<OnBoardGymSearch />} />
          <Route path="/gym" element={<OnBoardCreateGym />} />
          <Route path="/complete" element={<OnBoardComplete />} />
          <Route path="/partners" element={<FibudPartners />} />
        </Routes>
      </Suspense>
    </Fragment>
  );
}
